import React, { Component } from "react";
import { Form, Layout, Button, Row, Col, Popconfirm, Table } from "antd";
import "./index.scss";
import CreateUpdateModal from "./components/CreateUpdateModal";
import { checkPermission } from "../../utils/helper";
import { Redirect } from "react-router-dom";

const { Content } = Layout;

class RegistrationField extends Component {
  initialState = {
    registrationFieldsData: [],
    showCreateUpdateModal: false,
    selectedRow: {}
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleCreateButton = () => {
    this.setState({
      showCreateUpdateModal: true
    });
  };

  handleUpdateButton = (row) => {
    this.setState({
      showCreateUpdateModal: true,
      selectedRow: row
    });
  };

  handleDeleteButton = (row) => {
    this.props.onDeleteRegistrationField(row);
  }

  handleCloseModal = () => {
    this.setState({
      showCreateUpdateModal: false,
    });
  };

  componentDidMount() {
    const onGetParam = {
      event_id: this.props.event.id
    };
    this.props.onGetRegistrationFields(onGetParam);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.registrationFieldsData !== nextProps.registrationFieldsData) {
      this.setState({ registrationFieldsData: nextProps.registrationFieldsData });
    }
  }

  render() {
    const { registrationFieldsData, showCreateUpdateModal, selectedRow } = this.state;
    const { isLoading, } = this.props;
    const module = "registration-field";

    if (!checkPermission(module, "view")) {
      return (<Redirect to="/403" />);
    }

    const columns = [
      {
        title: 'Field Name',
        dataIndex: 'label',
        key: 'label',
      },
      {
        title: 'slug',
        dataIndex: 'query_slug',
        key: 'query_slug',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        align: 'center',
      },
      {
        title: 'Is Required',
        dataIndex: 'is_required',
        key: 'is_required',
        align: 'center',
        render: is_required => (
          <span>
            {parseInt(is_required) == 1 ? 'Yes' : 'No'}
          </span>
        ),
      },
      {
        title: 'Order',
        dataIndex: 'ordinality',
        key: 'ordinality',
        align: 'center',
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (text, record) => (
          <span>
            {(checkPermission(module, "edit")) ?
              <Button type="default" onClick={() => this.handleUpdateButton(record)}>Edit</Button> : ''
            }
            &nbsp;&nbsp;
            {/* <Divider type="vertical" /> */}
            {(checkPermission(module, "delete")) ?
              <Popconfirm
                title="Are you sure you want to delete?"
                onConfirm={() => this.handleDeleteButton(record)}
                okText="Proceed"
                cancelText="Cancel"
                disabled={!record.is_deletable}
              >
                <Button type="danger" disabled={!record.is_deletable}>Delete</Button>
              </Popconfirm> : ''
            }
          </span>
        ),
      },
    ];

    return (
      <Layout className="registration-field-container">
        <Content className="registration-field-content" style={{ padding: "20px 60px" }}>
          <Row type="flex" gutter={30}>
            <Col span={24}>
              <h2>Registration Fields</h2>
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={12} className="page-content-control-button-holder">
              {(checkPermission(module, "create")) ?
                <Button type="primary" loading={isLoading} onClick={this.handleCreateButton}>Add Field</Button> : ''
              }
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={24}>
              <Table columns={columns} dataSource={registrationFieldsData} loading={isLoading} rowKey={"id"} />
            </Col>
          </Row>
        </Content>

        <CreateUpdateModal showModal={showCreateUpdateModal} selectedRow={selectedRow} handleCloseModal={this.handleCloseModal} {...this.props} />
      </Layout>
    );
  }
}

const RegistrationFieldForm = Form.create({ name: "registration-field-form" })(RegistrationField);

export default RegistrationFieldForm;
